import styles from "./Small.module.scss";

export function Small({ ...otherProps }) {
  return <small {...otherProps} className={styles.small} />;
}
